import React, { useState, useEffect } from "react";
import "./navBar.scss";
import { Link } from "react-router-dom";
export default function NavBar() {
  const [gyvunai, setGyvunai] = useState("hide");
  const [parama, setParama] = useState("hide");
  const [gyvunaiActive, setGyvunaiActive] = useState("inactive");
  const [paramaActive, setParamaActive] = useState("inactive");
  const [phoneMenuActive, setPhoneMenuActive] = useState("phoneMenuNotActive");
  const [supportSubmenu, setSupportSubmenu] = useState(
    "supportSubmenuNotActive"
  );
  const [animalSubmenu, setAnimalSubmenu] = useState("animalSubmenuNotActive");
  function resetDropDowns() {
    setGyvunai("hide");
    setParama("hide");
    setGyvunaiActive("inactive");
    setParamaActive("inactive");
  }
  function togglePhoneMenu() {
    phoneMenuActive === "phoneMenuActive"
      ? setPhoneMenuActive("phoneMenuNotActive")
      : setPhoneMenuActive("phoneMenuActive");
  }
  function toggleSupportSubmenu() {
    supportSubmenu === "supportSubmenuActive"
      ? setSupportSubmenu("supportSubmenuNotActive")
      : setSupportSubmenu("supportSubmenuActive");
  }
  function toggleAnimalSubmenu() {
    animalSubmenu === "animalSubmenuActive"
      ? setAnimalSubmenu("animalSubmenuNotActive")
      : setAnimalSubmenu("animalSubmenuActive");
  }
  return (
    <div className="navBarWrapper">
      <div className="topNavBar" onMouseEnter={() => resetDropDowns()}>
        <div className="innerWrapper">
          <img src="/img/logo.png" class="mainLogo" alt="company logo"></img>
          <ul className="navBarTopInfoContainer">
            <li>
              <img src="/img/phone.svg" alt="phone icon"></img>
              <span className="navBarTopInfoField1">+370 604 36 652</span>
            </li>
            <li>
              <img src="/img/mail.svg" alt="email icon"></img>
              <span className="navBarTopInfoField2">egzoticsos@gmail.com</span>
            </li>
            <li>
              <img src="/img/loc.svg" alt="location icon"></img>
              <span className="navBarTopInfoField2">
                Prienų r. Dambravos k., Juodupės g. 28
              </span>
            </li>
            <li className="phoneMenuIcon">
              <svg
                onClick={() => {
                  togglePhoneMenu();
                  setSupportSubmenu("supportSubmenuNotActive");
                  setAnimalSubmenu("animalSubmenuNotActive");
                }}
                width="32"
                height="33"
                viewBox="0 0 32 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 6.12109H28V8.12109H4V6.12109ZM4 24.1211H28V26.1211H4V24.1211ZM4 12.1211H28V14.1211H4V12.1211ZM4 18.1211H28V20.1211H4V18.1211Z"
                  fill="#584C4D"
                />
              </svg>
              <div className={phoneMenuActive}>
                {/* Phone menu containeris */}
                <ul className="mobileNavitaionLinkContainer">
                  <li className="mobileNavigationLink">
                    <Link to="/">
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 30 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.612 0.713959C15.4346 0.575618 15.216 0.500488 14.991 0.500488C14.766 0.500488 14.5474 0.575618 14.37 0.713959L0 11.919L1.243 13.491L3 12.121V24.5C3.00106 25.0301 3.21211 25.5382 3.58695 25.913C3.9618 26.2878 4.46989 26.4989 5 26.5H25C25.5301 26.4989 26.0382 26.2878 26.413 25.913C26.7879 25.5382 26.9989 25.0301 27 24.5V12.13L28.757 13.5L30 11.928L15.612 0.713959ZM17 24.5H13V16.5H17V24.5ZM19 24.5V16.5C19 15.9695 18.7893 15.4608 18.4142 15.0857C18.0391 14.7107 17.5304 14.5 17 14.5H13C12.4696 14.5 11.9609 14.7107 11.5858 15.0857C11.2107 15.4608 11 15.9695 11 16.5V24.5H5V10.562L15 2.77196L25 10.572V24.5H19Z"
                          fill="black"
                        />
                      </svg>
                      Pagrindinis
                    </Link>
                  </li>
                  <li className="mobileNavigationLink">
                    <div
                      className="mobileNavigationLabel"
                      onClick={() => {
                        toggleAnimalSubmenu();
                      }}
                    >
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M22.9961 9.5C22.9968 9.39546 22.9829 9.29133 22.9548 9.19062L21.6086 4.48531C21.4958 4.09455 21.2594 3.75084 20.935 3.50562C20.6105 3.2604 20.2153 3.12686 19.8086 3.125H5.93359C5.52688 3.12686 5.13171 3.2604 4.80723 3.50562C4.48275 3.75084 4.24641 4.09455 4.13359 4.48531L2.78922 9.19062C2.76053 9.29124 2.74601 9.39537 2.74609 9.5V11C2.74599 11.6079 2.88044 12.2083 3.13978 12.7581C3.39912 13.3079 3.77692 13.7935 4.24609 14.18V20.75C4.24609 21.0484 4.36462 21.3345 4.5756 21.5455C4.78658 21.7565 5.07273 21.875 5.37109 21.875H20.3711C20.6695 21.875 20.9556 21.7565 21.1666 21.5455C21.3776 21.3345 21.4961 21.0484 21.4961 20.75V14.18C21.9653 13.7935 22.3431 13.3079 22.6024 12.7581C22.8617 12.2083 22.9962 11.6079 22.9961 11V9.5ZM6.21953 5.375H19.5273L20.3842 8.375H5.36266L6.21953 5.375ZM14.7508 10.625V11C14.7508 11.4973 14.5532 11.9742 14.2016 12.3258C13.85 12.6775 13.3731 12.875 12.8758 12.875C12.3785 12.875 11.9016 12.6775 11.55 12.3258C11.1983 11.9742 11.0008 11.4973 11.0008 11V10.625H14.7508ZM5.83984 12.5666C5.58046 12.3957 5.36758 12.1632 5.22031 11.8897C5.07303 11.6163 4.99599 11.3106 4.99609 11V10.625H8.74609V11C8.74609 11.4973 8.54855 11.9742 8.19692 12.3258C7.84529 12.6775 7.36837 12.875 6.87109 12.875C6.57525 12.8751 6.28368 12.8044 6.02078 12.6688C5.96389 12.629 5.9033 12.5947 5.83984 12.5666ZM19.2461 19.625H6.49609V15.1072C6.61984 15.1184 6.74453 15.125 6.87109 15.125C7.43335 15.1252 7.98967 15.01 8.50567 14.7867C9.02167 14.5634 9.48638 14.2366 9.87109 13.8266C10.2559 14.2365 10.7206 14.5632 11.2366 14.7865C11.7526 15.0099 12.3089 15.1251 12.8711 15.1251C13.4333 15.1251 13.9896 15.0099 14.5056 14.7865C15.0216 14.5632 15.4863 14.2365 15.8711 13.8266C16.2558 14.2366 16.7205 14.5634 17.2365 14.7867C17.7525 15.01 18.3088 15.1252 18.8711 15.125C18.9977 15.125 19.1223 15.1184 19.2461 15.1072V19.625ZM20.7461 11C20.7462 11.3106 20.6692 11.6163 20.5219 11.8897C20.3746 12.1632 20.1617 12.3957 19.9023 12.5666C19.8405 12.5951 19.7815 12.6293 19.7261 12.6688C19.4403 12.8152 19.1216 12.8858 18.8006 12.8737C18.4797 12.8616 18.1672 12.7673 17.8932 12.5998C17.6192 12.4323 17.3928 12.1972 17.2357 11.9171C17.0786 11.637 16.9961 11.3212 16.9961 11V10.625H20.7461V11Z"
                          fill="#110F0F"
                        />
                      </svg>
                      Gyvūnai
                    </div>
                    <svg
                      width="33"
                      height="33"
                      viewBox="0 0 33 33"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22.8727 16.5L12.8727 26.5L11.4727 25.1L20.0727 16.5L11.4727 7.9L12.8727 6.5L22.8727 16.5Z"
                        fill="#110F0F"
                      />
                    </svg>
                  </li>
                  <li className="mobileNavigationLink">
                    <div
                      className="mobileNavigationLabel"
                      onClick={() => {
                        //parodyti phone menu paramos submenu
                        toggleSupportSubmenu();
                      }}
                    >
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 33 33"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.4316 10.5006C18.0758 10.5005 17.7237 10.5718 17.3959 10.7102C17.0682 10.8487 16.7716 11.0515 16.5236 11.3066L16.1306 11.7116L15.7336 11.3066C15.4857 11.0514 15.1891 10.8485 14.8614 10.7099C14.5336 10.5714 14.1814 10.5 13.8256 10.5C13.4698 10.5 13.1176 10.5714 12.7899 10.7099C12.4621 10.8485 12.1655 11.0514 11.9176 11.3066C11.4118 11.8289 11.1289 12.5275 11.1289 13.2546C11.1289 13.9817 11.4118 14.6803 11.9176 15.2026L16.1306 19.5006L20.3396 15.2026C20.8455 14.6803 21.1283 13.9817 21.1283 13.2546C21.1283 12.5275 20.8455 11.8289 20.3396 11.3066C20.0916 11.0515 19.795 10.8487 19.4673 10.7102C19.1396 10.5718 18.7874 10.5005 18.4316 10.5006Z"
                          fill="#110F0F"
                        />
                        <path
                          d="M17.8649 30.5L16.1289 29.5L20.1289 22.5H26.1289C26.3917 22.5004 26.6519 22.4489 26.8947 22.3486C27.1376 22.2482 27.3582 22.1009 27.544 21.9151C27.7298 21.7293 27.8771 21.5087 27.9775 21.2658C28.0778 21.023 28.1293 20.7628 28.1289 20.5V8.5C28.1293 8.23725 28.0778 7.977 27.9775 7.73417C27.8771 7.49134 27.7298 7.2707 27.544 7.08491C27.3582 6.89911 27.1376 6.75181 26.8947 6.65144C26.6519 6.55107 26.3917 6.4996 26.1289 6.5H6.12891C5.86615 6.4996 5.6059 6.55107 5.36307 6.65144C5.12024 6.75181 4.89961 6.89911 4.71381 7.08491C4.52802 7.2707 4.38071 7.49134 4.28034 7.73417C4.17997 7.977 4.12851 8.23725 4.12891 8.5V20.5C4.12851 20.7628 4.17997 21.023 4.28034 21.2658C4.38071 21.5087 4.52802 21.7293 4.71381 21.9151C4.89961 22.1009 5.12024 22.2482 5.36307 22.3486C5.6059 22.4489 5.86615 22.5004 6.12891 22.5H15.1289V24.5H6.12891C5.06804 24.5 4.05062 24.0786 3.30048 23.3284C2.55033 22.5783 2.12891 21.5609 2.12891 20.5V8.5C2.12891 7.43913 2.55033 6.42172 3.30048 5.67157C4.05062 4.92143 5.06804 4.5 6.12891 4.5H26.1289C27.1898 4.5 28.2072 4.92143 28.9573 5.67157C29.7075 6.42172 30.1289 7.43913 30.1289 8.5V20.5C30.1289 21.5609 29.7075 22.5783 28.9573 23.3284C28.2072 24.0786 27.1898 24.5 26.1289 24.5H21.2939L17.8649 30.5Z"
                          fill="#110F0F"
                        />
                      </svg>
                      Parama
                    </div>
                    <svg
                      width="33"
                      height="33"
                      viewBox="0 0 33 33"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22.8727 16.5L12.8727 26.5L11.4727 25.1L20.0727 16.5L11.4727 7.9L12.8727 6.5L22.8727 16.5Z"
                        fill="#110F0F"
                      />
                    </svg>
                  </li>
                  <li className="mobileNavigationLink">
                    <Link to="/volunteering">
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.8711 2.375C10.8686 2.375 8.911 2.96882 7.24595 4.08137C5.5809 5.19392 4.28316 6.77523 3.51682 8.62533C2.75048 10.4754 2.54997 12.5112 2.94065 14.4753C3.33132 16.4393 4.29564 18.2435 5.71164 19.6595C7.12765 21.0755 8.93175 22.0398 10.8958 22.4305C12.8599 22.8211 14.8957 22.6206 16.7458 21.8543C18.5959 21.0879 20.1772 19.7902 21.2897 18.1251C22.4023 16.4601 22.9961 14.5025 22.9961 12.5C22.9931 9.8156 21.9254 7.24199 20.0273 5.34383C18.1291 3.44567 15.5555 2.37798 12.8711 2.375ZM12.8711 20.375C11.3136 20.375 9.79102 19.9131 8.49598 19.0478C7.20095 18.1825 6.19159 16.9526 5.59555 15.5136C4.99951 14.0747 4.84356 12.4913 5.14741 10.9637C5.45127 9.43606 6.20129 8.03287 7.30263 6.93153C8.40397 5.8302 9.80716 5.08017 11.3348 4.77632C12.8624 4.47246 14.4458 4.62841 15.8847 5.22445C17.3237 5.82049 18.5536 6.82985 19.4189 8.12488C20.2842 9.41992 20.7461 10.9425 20.7461 12.5C20.7439 14.5879 19.9135 16.5896 18.4371 18.066C16.9607 19.5424 14.959 20.3728 12.8711 20.375ZM19.2461 12.5C19.2461 12.7984 19.1276 13.0845 18.9166 13.2955C18.7056 13.5065 18.4195 13.625 18.1211 13.625H12.8711C12.5727 13.625 12.2866 13.5065 12.0756 13.2955C11.8646 13.0845 11.7461 12.7984 11.7461 12.5V7.25C11.7461 6.95163 11.8646 6.66548 12.0756 6.4545C12.2866 6.24353 12.5727 6.125 12.8711 6.125C13.1695 6.125 13.4556 6.24353 13.6666 6.4545C13.8776 6.66548 13.9961 6.95163 13.9961 7.25V11.375H18.1211C18.4195 11.375 18.7056 11.4935 18.9166 11.7045C19.1276 11.9155 19.2461 12.2016 19.2461 12.5Z"
                          fill="#110F0F"
                        />
                      </svg>
                      Savanorystė
                    </Link>
                  </li>
                  <li className="mobileNavigationLink">
                    <Link to="/education">
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.8711 2.375C10.8686 2.375 8.911 2.96882 7.24595 4.08137C5.5809 5.19392 4.28316 6.77523 3.51682 8.62533C2.75048 10.4754 2.54997 12.5112 2.94065 14.4753C3.33132 16.4393 4.29564 18.2435 5.71164 19.6595C7.12765 21.0755 8.93175 22.0398 10.8958 22.4305C12.8599 22.8211 14.8957 22.6206 16.7458 21.8543C18.5959 21.0879 20.1772 19.7902 21.2897 18.1251C22.4023 16.4601 22.9961 14.5025 22.9961 12.5C22.9931 9.8156 21.9254 7.24199 20.0273 5.34383C18.1291 3.44567 15.5555 2.37798 12.8711 2.375ZM12.8711 20.375C11.3136 20.375 9.79102 19.9131 8.49598 19.0478C7.20095 18.1825 6.19159 16.9526 5.59555 15.5136C4.99951 14.0747 4.84356 12.4913 5.14741 10.9637C5.45127 9.43606 6.20129 8.03287 7.30263 6.93153C8.40397 5.8302 9.80716 5.08017 11.3348 4.77632C12.8624 4.47246 14.4458 4.62841 15.8847 5.22445C17.3237 5.82049 18.5536 6.82985 19.4189 8.12488C20.2842 9.41992 20.7461 10.9425 20.7461 12.5C20.7439 14.5879 19.9135 16.5896 18.4371 18.066C16.9607 19.5424 14.959 20.3728 12.8711 20.375ZM19.2461 12.5C19.2461 12.7984 19.1276 13.0845 18.9166 13.2955C18.7056 13.5065 18.4195 13.625 18.1211 13.625H12.8711C12.5727 13.625 12.2866 13.5065 12.0756 13.2955C11.8646 13.0845 11.7461 12.7984 11.7461 12.5V7.25C11.7461 6.95163 11.8646 6.66548 12.0756 6.4545C12.2866 6.24353 12.5727 6.125 12.8711 6.125C13.1695 6.125 13.4556 6.24353 13.6666 6.4545C13.8776 6.66548 13.9961 6.95163 13.9961 7.25V11.375H18.1211C18.4195 11.375 18.7056 11.4935 18.9166 11.7045C19.1276 11.9155 19.2461 12.2016 19.2461 12.5Z"
                          fill="#110F0F"
                        />
                      </svg>
                      Edukacija
                    </Link>
                  </li>
                  <li className="mobileNavigationLink">
                    <Link to="/animalCare">
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21.8711 4.625H15.8711C15.3088 4.62482 14.7525 4.73995 14.2365 4.96328C13.7205 5.18662 13.2558 5.5134 12.8711 5.92344C12.4864 5.5134 12.0217 5.18662 11.5057 4.96328C10.9897 4.73995 10.4334 4.62482 9.87109 4.625H3.87109C3.37381 4.625 2.8969 4.82254 2.54527 5.17418C2.19364 5.52581 1.99609 6.00272 1.99609 6.5V18.5C1.99609 18.9973 2.19364 19.4742 2.54527 19.8258C2.8969 20.1775 3.37381 20.375 3.87109 20.375H9.87109C10.3684 20.375 10.8453 20.5725 11.1969 20.9242C11.5485 21.2758 11.7461 21.7527 11.7461 22.25C11.7461 22.5484 11.8646 22.8345 12.0756 23.0455C12.2866 23.2565 12.5727 23.375 12.8711 23.375C13.1695 23.375 13.4556 23.2565 13.6666 23.0455C13.8776 22.8345 13.9961 22.5484 13.9961 22.25C13.9961 21.7527 14.1936 21.2758 14.5453 20.9242C14.8969 20.5725 15.3738 20.375 15.8711 20.375H21.8711C22.3684 20.375 22.8453 20.1775 23.1969 19.8258C23.5485 19.4742 23.7461 18.9973 23.7461 18.5V6.5C23.7461 6.00272 23.5485 5.52581 23.1969 5.17418C22.8453 4.82254 22.3684 4.625 21.8711 4.625ZM9.87109 18.125H4.24609V6.875H9.87109C10.3684 6.875 10.8453 7.07254 11.1969 7.42418C11.5485 7.77581 11.7461 8.25272 11.7461 8.75V18.5759C11.1658 18.2789 10.523 18.1243 9.87109 18.125ZM21.4961 18.125H15.8711C15.219 18.1246 14.5762 18.2798 13.9961 18.5778V8.75C13.9961 8.25272 14.1936 7.77581 14.5453 7.42418C14.8969 7.07254 15.3738 6.875 15.8711 6.875H21.4961V18.125ZM16.2461 9.5H19.2461C19.5445 9.5 19.8306 9.61853 20.0416 9.8295C20.2526 10.0405 20.3711 10.3266 20.3711 10.625C20.3711 10.9234 20.2526 11.2095 20.0416 11.4205C19.8306 11.6315 19.5445 11.75 19.2461 11.75H16.2461C15.9477 11.75 15.6616 11.6315 15.4506 11.4205C15.2396 11.2095 15.1211 10.9234 15.1211 10.625C15.1211 10.3266 15.2396 10.0405 15.4506 9.8295C15.6616 9.61853 15.9477 9.5 16.2461 9.5ZM20.3711 14.375C20.3711 14.6734 20.2526 14.9595 20.0416 15.1705C19.8306 15.3815 19.5445 15.5 19.2461 15.5H16.2461C15.9477 15.5 15.6616 15.3815 15.4506 15.1705C15.2396 14.9595 15.1211 14.6734 15.1211 14.375C15.1211 14.0766 15.2396 13.7905 15.4506 13.5795C15.6616 13.3685 15.9477 13.25 16.2461 13.25H19.2461C19.5445 13.25 19.8306 13.3685 20.0416 13.5795C20.2526 13.7905 20.3711 14.0766 20.3711 14.375Z"
                          fill="#110F0F"
                        />
                      </svg>
                      Gyvūnų priežiūra
                    </Link>
                  </li>
                  <li className="mobileNavigationLink">
                    <Link to="/performanceReports">
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.8711 2.375C10.8686 2.375 8.911 2.96882 7.24595 4.08137C5.5809 5.19392 4.28316 6.77523 3.51682 8.62533C2.75048 10.4754 2.54997 12.5112 2.94065 14.4753C3.33132 16.4393 4.29564 18.2435 5.71164 19.6595C7.12765 21.0755 8.93175 22.0398 10.8958 22.4305C12.8599 22.8211 14.8957 22.6206 16.7458 21.8543C18.5959 21.0879 20.1772 19.7902 21.2897 18.1251C22.4023 16.4601 22.9961 14.5025 22.9961 12.5C22.9931 9.8156 21.9254 7.24199 20.0273 5.34383C18.1291 3.44567 15.5555 2.37798 12.8711 2.375ZM12.8711 20.375C11.3136 20.375 9.79102 19.9131 8.49598 19.0478C7.20095 18.1825 6.19159 16.9526 5.59555 15.5136C4.99951 14.0747 4.84356 12.4913 5.14741 10.9637C5.45127 9.43606 6.20129 8.03287 7.30263 6.93153C8.40397 5.8302 9.80716 5.08017 11.3348 4.77632C12.8624 4.47246 14.4458 4.62841 15.8847 5.22445C17.3237 5.82049 18.5536 6.82985 19.4189 8.12488C20.2842 9.41992 20.7461 10.9425 20.7461 12.5C20.7439 14.5879 19.9135 16.5896 18.4371 18.066C16.9607 19.5424 14.959 20.3728 12.8711 20.375ZM19.2461 12.5C19.2461 12.7984 19.1276 13.0845 18.9166 13.2955C18.7056 13.5065 18.4195 13.625 18.1211 13.625H12.8711C12.5727 13.625 12.2866 13.5065 12.0756 13.2955C11.8646 13.0845 11.7461 12.7984 11.7461 12.5V7.25C11.7461 6.95163 11.8646 6.66548 12.0756 6.4545C12.2866 6.24353 12.5727 6.125 12.8711 6.125C13.1695 6.125 13.4556 6.24353 13.6666 6.4545C13.8776 6.66548 13.9961 6.95163 13.9961 7.25V11.375H18.1211C18.4195 11.375 18.7056 11.4935 18.9166 11.7045C19.1276 11.9155 19.2461 12.2016 19.2461 12.5Z"
                          fill="#110F0F"
                        />
                      </svg>
                      Veiklos ataskaitos
                    </Link>
                  </li>
                  <li className="mobileNavigationLink">
                    <Link to="/contacts">
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21.8711 15.0126L17.4564 13.0335L17.4395 13.026C17.1526 12.9023 16.8392 12.8525 16.528 12.8812C16.2168 12.9098 15.9178 13.016 15.6583 13.1901C15.6219 13.2144 15.5869 13.2407 15.5533 13.2688L13.4617 15.0501C12.243 14.3891 10.9839 13.1404 10.322 11.9366L12.1089 9.81226C12.1376 9.77798 12.1642 9.74197 12.1886 9.70445C12.3581 9.44585 12.461 9.14934 12.4881 8.84134C12.5153 8.53334 12.4658 8.22341 12.3442 7.93914C12.3413 7.93369 12.3388 7.92806 12.3367 7.92226L10.3586 3.50008C10.1962 3.13025 9.91911 2.82253 9.56825 2.62245C9.21739 2.42237 8.81144 2.34057 8.41048 2.38914C7.04957 2.56791 5.80028 3.23596 4.89592 4.2685C3.99156 5.30105 3.49397 6.62748 3.4961 8.00008C3.4961 15.651 9.72016 21.8751 17.3711 21.8751C18.7437 21.8772 20.0701 21.3796 21.1027 20.4753C22.1352 19.5709 22.8033 18.3216 22.982 16.9607C23.0306 16.5597 22.9488 16.1538 22.7487 15.8029C22.5486 15.4521 22.2409 15.1749 21.8711 15.0126ZM17.3711 19.6251C14.2891 19.6214 11.3344 18.3954 9.15509 16.2161C6.97579 14.0368 5.74982 11.0821 5.7461 8.00008C5.74395 7.22335 6.00765 6.46928 6.49336 5.86316C6.97908 5.25703 7.65757 4.83536 8.4161 4.6682L10.1805 8.6057L8.38423 10.7451C8.35519 10.7797 8.32827 10.816 8.3036 10.8538C8.12655 11.1243 8.02246 11.436 8.00144 11.7587C7.98041 12.0813 8.04316 12.4039 8.1836 12.6951C9.06673 14.5026 10.8864 16.3101 12.7127 17.1951C13.0058 17.3341 13.33 17.3946 13.6536 17.3708C13.9771 17.3469 14.289 17.2396 14.5586 17.0591C14.5949 17.0347 14.6296 17.0081 14.6627 16.9795L16.7655 15.1916L20.703 16.9551C20.5358 17.7136 20.1141 18.3921 19.508 18.8778C18.9019 19.3635 18.1478 19.6272 17.3711 19.6251Z"
                          fill="#110F0F"
                        />
                      </svg>
                      Kontaktai
                    </Link>
                  </li>
                </ul>
                {/* Phone menu conteinerio pabaiga */}
              </div>
              <div className={supportSubmenu}>
                <div
                  className="backFromSupportButton"
                  onClick={() => {
                    setSupportSubmenu("supportSubmenuNotActive");
                  }}
                >
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.62891 12.5L15.1289 5L16.1789 6.05L9.72891 12.5L16.1789 18.95L15.1289 20L7.62891 12.5Z"
                      fill="#110F0F"
                    />
                  </svg>
                  Atgal
                </div>
                <div className="supportMenuHeader">
                  <svg
                    width="33"
                    height="33"
                    viewBox="0 0 33 33"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.4316 10.5006C18.0758 10.5005 17.7237 10.5718 17.3959 10.7102C17.0682 10.8487 16.7716 11.0515 16.5236 11.3066L16.1306 11.7116L15.7336 11.3066C15.4857 11.0514 15.1891 10.8485 14.8614 10.7099C14.5336 10.5714 14.1814 10.5 13.8256 10.5C13.4698 10.5 13.1176 10.5714 12.7899 10.7099C12.4621 10.8485 12.1655 11.0514 11.9176 11.3066C11.4118 11.8289 11.1289 12.5275 11.1289 13.2546C11.1289 13.9817 11.4118 14.6803 11.9176 15.2026L16.1306 19.5006L20.3396 15.2026C20.8455 14.6803 21.1283 13.9817 21.1283 13.2546C21.1283 12.5275 20.8455 11.8289 20.3396 11.3066C20.0916 11.0515 19.795 10.8487 19.4673 10.7102C19.1396 10.5718 18.7874 10.5005 18.4316 10.5006Z"
                      fill="#110F0F"
                    />
                    <path
                      d="M17.8649 30.5L16.1289 29.5L20.1289 22.5H26.1289C26.3917 22.5004 26.6519 22.4489 26.8947 22.3486C27.1376 22.2482 27.3582 22.1009 27.544 21.9151C27.7298 21.7293 27.8771 21.5087 27.9775 21.2658C28.0778 21.023 28.1293 20.7628 28.1289 20.5V8.5C28.1293 8.23725 28.0778 7.977 27.9775 7.73417C27.8771 7.49134 27.7298 7.2707 27.544 7.08491C27.3582 6.89911 27.1376 6.75181 26.8947 6.65144C26.6519 6.55107 26.3917 6.4996 26.1289 6.5H6.12891C5.86615 6.4996 5.6059 6.55107 5.36307 6.65144C5.12024 6.75181 4.89961 6.89911 4.71381 7.08491C4.52802 7.2707 4.38071 7.49134 4.28034 7.73417C4.17997 7.977 4.12851 8.23725 4.12891 8.5V20.5C4.12851 20.7628 4.17997 21.023 4.28034 21.2658C4.38071 21.5087 4.52802 21.7293 4.71381 21.9151C4.89961 22.1009 5.12024 22.2482 5.36307 22.3486C5.6059 22.4489 5.86615 22.5004 6.12891 22.5H15.1289V24.5H6.12891C5.06804 24.5 4.05062 24.0786 3.30048 23.3284C2.55033 22.5783 2.12891 21.5609 2.12891 20.5V8.5C2.12891 7.43913 2.55033 6.42172 3.30048 5.67157C4.05062 4.92143 5.06804 4.5 6.12891 4.5H26.1289C27.1898 4.5 28.2072 4.92143 28.9573 5.67157C29.7075 6.42172 30.1289 7.43913 30.1289 8.5V20.5C30.1289 21.5609 29.7075 22.5783 28.9573 23.3284C28.2072 24.0786 27.1898 24.5 26.1289 24.5H21.2939L17.8649 30.5Z"
                      fill="#110F0F"
                    />
                  </svg>
                  Parama
                </div>
                <ul className="mobileNavitaionLinkContainer">
                  <li className="mobileNavigationLink">
                    <Link to="/gpmSupport">1,2 proc GMP</Link>
                  </li>
                  <li className="mobileNavigationLink">
                    <Link to="/materialSupport">Parama daiktais</Link>
                  </li>
                  <li className="mobileNavigationLink">
                    <Link to="/monetarySupport">Finansinės paramos</Link>
                  </li>
                  <li className="mobileNavigationLink">
                    <span
                      className="mobileNavigationLinkSpan"
                      onClick={() =>
                        window.open(
                          "https://www.patreon.com/egzoticsos",
                          "_blank"
                        )
                      }
                    >
                      Patreon
                    </span>
                  </li>
                  <li className="mobileNavigationLink">
                    <span
                      className="mobileNavigationLinkSpan"
                      onClick={() =>
                        window.open(
                          "https://www.paypal.com/donate/?hosted_button_id=TF3JYZG45XDUQ",
                          "_blank"
                        )
                      }
                    >
                      Paypal
                    </span>
                  </li>
                  <li className="mobileNavigationLink">
                    <Link
                      to="monetarySupport"
                      className="mobileNavigationLinkSpan"
                    >
                      Bankinis pavedimas
                    </Link>
                  </li>
                </ul>
              </div>

              <div className={animalSubmenu}>
                <div
                  className="backFromSupportButton"
                  onClick={() => {
                    setAnimalSubmenu("animalSubmenuNotActive");
                  }}
                >
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.62891 12.5L15.1289 5L16.1789 6.05L9.72891 12.5L16.1789 18.95L15.1289 20L7.62891 12.5Z"
                      fill="#110F0F"
                    />
                  </svg>
                  Atgal
                </div>
                <div className="supportMenuHeader">
                  <svg
                    width="32"
                    height="33"
                    viewBox="0 0 32 33"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M29.5 12.5C29.5009 12.3606 29.4824 12.2218 29.445 12.0875L27.65 5.81375C27.4996 5.29274 27.1845 4.83445 26.7518 4.50749C26.3192 4.18053 25.7923 4.00249 25.25 4H6.75C6.20771 4.00249 5.68082 4.18053 5.24818 4.50749C4.81554 4.83445 4.50042 5.29274 4.35 5.81375L2.5575 12.0875C2.51925 12.2217 2.49989 12.3605 2.5 12.5V14.5C2.49987 15.3105 2.67912 16.111 3.02491 16.8441C3.3707 17.5772 3.87444 18.2246 4.5 18.74V27.5C4.5 27.8978 4.65804 28.2794 4.93934 28.5607C5.22064 28.842 5.60218 29 6 29H26C26.3978 29 26.7794 28.842 27.0607 28.5607C27.342 28.2794 27.5 27.8978 27.5 27.5V18.74C28.1256 18.2246 28.6293 17.5772 28.9751 16.8441C29.3209 16.111 29.5001 15.3105 29.5 14.5V12.5ZM7.13125 7H24.875L26.0175 11H5.98875L7.13125 7ZM18.5063 14V14.5C18.5063 15.163 18.2429 15.7989 17.774 16.2678C17.3052 16.7366 16.6693 17 16.0063 17C15.3432 17 14.7073 16.7366 14.2385 16.2678C13.7696 15.7989 13.5063 15.163 13.5063 14.5V14H18.5063ZM6.625 16.5888C6.27916 16.361 5.99531 16.0509 5.79895 15.6863C5.60259 15.3217 5.49986 14.9141 5.5 14.5V14H10.5V14.5C10.5 15.163 10.2366 15.7989 9.76777 16.2678C9.29893 16.7366 8.66304 17 8 17C7.60555 17.0002 7.21679 16.9059 6.86625 16.725C6.79039 16.6719 6.7096 16.6263 6.625 16.5888ZM24.5 26H7.5V19.9762C7.665 19.9913 7.83125 20 8 20C8.74968 20.0002 9.49144 19.8467 10.1794 19.549C10.8674 19.2512 11.4871 18.8155 12 18.2687C12.5131 18.8153 13.1327 19.2509 13.8207 19.5487C14.5086 19.8465 15.2503 20.0001 16 20.0001C16.7497 20.0001 17.4914 19.8465 18.1793 19.5487C18.8673 19.2509 19.4869 18.8153 20 18.2687C20.5129 18.8155 21.1326 19.2512 21.8206 19.549C22.5086 19.8467 23.2503 20.0002 24 20C24.1688 20 24.335 19.9913 24.5 19.9762V26ZM26.5 14.5C26.5001 14.9141 26.3974 15.3217 26.2011 15.6863C26.0047 16.0509 25.7208 16.361 25.375 16.5888C25.2926 16.6268 25.2139 16.6724 25.14 16.725C24.7589 16.9203 24.334 17.0144 23.9061 16.9983C23.4781 16.9822 23.0615 16.8565 22.6961 16.6331C22.3308 16.4098 22.0289 16.0963 21.8194 15.7228C21.61 15.3493 21.5 14.9282 21.5 14.5V14H26.5V14.5Z"
                      fill="#110F0F"
                    />
                  </svg>
                  Gyvūnai
                </div>
                <ul className="mobileNavitaionLinkContainer">
                  <li className="mobileNavigationLink">
                    <Link to="/allAnimals">Visi priglausti</Link>
                  </li>
                  <li className="mobileNavigationLink">
                    <Link to="/lookingForHome">Dovanojami</Link>
                  </li>
                  <li className="mobileNavigationLink">
                    <Link to="/underCare">Globojami</Link>
                  </li>
                  <li className="mobileNavigationLink">
                    <Link to="/foundHome">Padovanoti</Link>
                  </li>
                  <li className="mobileNavigationLink">
                    <Link to="/remainsInMemory">Liks atmintyje</Link>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className="bottomNavBar">
        <div className="innerWrapper">
          <ul>
            <li>
              <Link
                to="/"
                onMouseEnter={() => {
                  resetDropDowns();
                }}
              >
                Pagrindinis
              </Link>
            </li>
            <li>
              <a
                href="/"
                onMouseEnter={() => {
                  resetDropDowns();
                  setGyvunai("show");
                  setGyvunaiActive("active");
                }}
                onClick={(e) => e.preventDefault()}
                className={gyvunaiActive}
              >
                Gyvūnai
                <svg
                  width="16"
                  height="10"
                  viewBox="0 0 16 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.75 9.07344L0.25 1.57344L1.3 0.523438L7.75 6.97344L14.2 0.523438L15.25 1.57344L7.75 9.07344Z"
                    fill="#584C4D"
                  />
                </svg>
              </a>
              <div
                id="gyvunuDropDown"
                className={gyvunai}
                onMouseLeave={() => resetDropDowns()}
              >
                <ul>
                  <li>
                    <Link to="/allAnimals" onMouseEnter={() => {}}>
                      Visi priglausti
                    </Link>
                  </li>
                  <li>
                    <Link to="/lookingForHome" onMouseEnter={() => {}}>
                      Dovanojami
                    </Link>
                  </li>
                  <li>
                    <Link to="/underCare" onMouseEnter={() => {}}>
                      Globojami
                    </Link>
                  </li>
                  <li>
                    <Link to="/foundHome" onMouseEnter={() => {}}>
                      Padovanoti
                    </Link>
                  </li>
                  <li>
                    <Link to="/remainsInMemory" onMouseEnter={() => {}}>
                      Liks atminty
                    </Link>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <a
                href="/"
                onMouseEnter={() => {
                  resetDropDowns();
                  setParama("show");
                  setParamaActive("active");
                }}
                onClick={(e) => {
                  e.preventDefault();
                }}
                className={paramaActive}
              >
                Parama
                <svg
                  width="16"
                  height="10"
                  viewBox="0 0 16 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.75 9.07344L0.25 1.57344L1.3 0.523438L7.75 6.97344L14.2 0.523438L15.25 1.57344L7.75 9.07344Z"
                    fill="#584C4D"
                  />
                </svg>
              </a>
              <div
                id="paramosDropDown"
                className={parama}
                onMouseLeave={() => resetDropDowns()}
              >
                <ul>
                  <li>
                    <Link to="/gpmSupport">1,2 proc. GMP</Link>
                  </li>
                  <li>
                    <Link to="/materialSupport">Parama daiktais</Link>
                  </li>
                  <li>
                    <Link to="/monetarySupport">Finansinė parama</Link>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <Link
                to="/volunteering"
                onMouseEnter={() => {
                  resetDropDowns();
                }}
              >
                Savanorystė
              </Link>
            </li>
            <li>
              <Link
                to="/education"
                onMouseEnter={() => {
                  resetDropDowns();
                }}
              >
                Edukacija
              </Link>
            </li>
            <li>
              <Link
                to="/animalCare"
                onMouseEnter={() => {
                  resetDropDowns();
                  // setPrieziura("show");
                }}
                onClick={() => {
                  resetDropDowns();
                }}
              >
                Gyvūnų priežiūra
                {/* <svg
                  width="16"
                  height="10"
                  viewBox="0 0 16 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.75 9.07344L0.25 1.57344L1.3 0.523438L7.75 6.97344L14.2 0.523438L15.25 1.57344L7.75 9.07344Z"
                    fill="#584C4D"
                  />
                </svg> */}
              </Link>

              {/* <div
                id="prieziuriosDropDown"
                className={prieziura}
                onMouseLeave={() => resetDropDowns()}
              >
                <img src="/img/iguana.png" alt="iguana"></img>
                <div className="animalListsContainer">
                  <div className="animaListColumnContainer">
                    <div className="animalListColumnHeader">
                      <svg
                        width="28"
                        height="24"
                        viewBox="0 0 28 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.84258 23.2908C6.2629 23.0616 5.29821 22.404 4.6969 21.8286C3.72355 20.8986 3.47696 20.838 2.48199 21.2966C1.58218 21.7075 1.25341 21.6989 0.842443 21.2619C0.47906 20.8769 0.466082 20.665 0.794857 20.5438C2.42575 19.4485 2.5512 19.3369 2.33491 16.9489C2.16187 15.0542 1.94556 14.4918 1.30532 14.2885C0.150282 13.9207 0.55808 12.4196 1.95855 13.0512C3.85765 13.0512 4.04367 12.013 2.42575 10.4427C-0.528892 7.57453 0.219501 2.7727 3.91822 0.86061C5.813 -0.117062 6.84258 0.0992349 8.29611 1.77772C9.56795 3.24855 9.68908 3.29613 11.0301 2.82893C12.8211 2.20599 15.1571 2.20599 16.9438 2.82893C18.2848 3.29613 18.4059 3.24855 19.6778 1.77772C21.2048 0.0127153 22.3556 -0.164652 24.3628 1.0596C27.0795 2.71645 28.0745 5.81386 26.7983 8.64738C26.3874 9.56016 25.6 10.5984 25.0506 10.9618C23.7658 11.8053 24.3628 13.4276 26.0024 13.0555C27.391 13.0555 27.8755 14.0678 26.6383 14.3923C25.9461 14.574 25.7515 14.9547 25.7471 16.1486C25.7471 16.9879 25.6303 18.0953 25.4919 18.6144C25.2929 19.3542 25.4703 19.6397 26.3398 19.9685C26.9454 20.1978 27.4386 20.5871 27.4386 20.8293C27.4386 21.5518 26.3138 21.7681 25.3275 21.2403C24.5445 20.8207 24.2503 20.9072 23.2986 21.8113C22.6887 22.3954 21.6548 23.0745 21.0015 23.3211C19.522 23.8792 8.27015 23.8619 6.85123 23.2952L6.84258 23.2908ZM21.8062 21.0976L22.9525 20.1112L21.8018 19.8214C20.4305 19.4753 20.4045 17.9872 21.7716 18.2511C23.7053 18.6231 23.8567 18.5322 23.9865 16.9489L24.1162 15.3829L22.6757 15.9842C21.884 16.3173 21.114 16.4688 20.9712 16.3217C20.3396 15.6901 20.8112 14.9676 22.1349 14.5307L23.5625 14.0592L22.7795 12.5018C22.3512 11.6453 21.9013 10.46 21.7845 9.8673C20.8501 5.11737 14.4477 2.45257 10.0092 4.97029C8.20959 5.99123 6.53111 8.14556 6.18936 9.8673C6.07256 10.46 5.62698 11.6453 5.19438 12.5018L4.41138 14.0592L5.83895 14.5307C7.1627 14.9676 7.62991 15.6901 7.00265 16.3217C6.85556 16.4644 6.10284 16.3217 5.32416 15.9929L3.90524 15.4002V16.8235C3.90524 18.5366 4.3162 18.861 5.77406 18.303C6.65224 17.9699 6.92477 18.0175 7.13242 18.5539C7.36602 19.1595 6.98101 19.6181 5.79569 20.1545C5.56641 20.2583 5.82165 20.7342 6.36672 21.21C7.27951 22.006 7.88947 22.0752 14.0107 22.0752C20.132 22.0752 20.7117 22.032 21.8105 21.0889L21.8062 21.0976ZM11.5622 20.3621C10.4504 19.9425 10.0005 19.0254 10.3985 17.9872C10.6494 17.3296 10.7576 17.3599 11.4368 18.2597C11.8607 18.8221 12.4058 19.1336 12.6697 18.9692C13.3575 18.5452 13.2623 18.0088 12.263 16.6548C10.71 14.5567 12.2587 12.7398 15.01 13.4276C16.4809 13.7953 16.788 15.2012 15.7108 16.6548C14.7115 18.0088 14.6164 18.5452 15.3042 18.9692C15.5724 19.1336 16.1175 18.8221 16.5371 18.2597C17.2163 17.3599 17.3244 17.334 17.5753 17.9872C18.1896 19.5835 16.2819 21.1538 14.7202 20.3362C14.2746 20.1026 13.6949 20.1026 13.2494 20.3362C12.8254 20.5568 12.1073 20.5698 11.5579 20.3621H11.5622ZM14.6164 15.3613C14.7591 15.132 14.4736 14.9417 13.9848 14.9417C13.4959 14.9417 13.2104 15.132 13.3532 15.3613C13.4959 15.5906 13.7815 15.7809 13.9848 15.7809C14.1881 15.7809 14.4736 15.5906 14.6164 15.3613ZM9.36463 11.1608C9.36463 10.3215 9.5766 9.90191 9.99622 9.90191C10.4158 9.90191 10.6278 10.3215 10.6278 11.1608C10.6278 12 10.4158 12.4196 9.99622 12.4196C9.5766 12.4196 9.36463 12 9.36463 11.1608ZM17.3461 11.1608C17.3461 10.3215 17.558 9.90191 17.9777 9.90191C18.3973 9.90191 18.6093 10.3215 18.6093 11.1608C18.6093 12 18.3973 12.4196 17.9777 12.4196C17.558 12.4196 17.3461 12 17.3461 11.1608ZM4.86993 8.74254C4.99971 8.10662 5.80002 6.77423 6.65657 5.77925L8.20959 3.97098L7.2449 2.94141C5.97739 1.5917 4.95213 1.64361 3.45101 3.1404C1.91961 4.6718 1.7682 7.09867 3.09195 8.7858C4.19508 10.1917 4.58009 10.1788 4.86993 8.73822V8.74254ZM24.8776 8.79013C26.2057 7.103 26.05 4.6718 24.5186 3.14473C23.0218 1.64794 21.9965 1.59169 20.7247 2.94572L19.76 3.97531L21.313 5.78357C22.1652 6.77855 22.9699 8.11095 23.0996 8.74687C23.3895 10.1917 23.7745 10.2004 24.8776 8.79446V8.79013Z"
                          fill="#110F0F"
                        />
                      </svg>
                      <span>Graužikai</span>
                    </div>
                    <div className="animalListColumn">
                      <Link to="/degu">Degu</Link>
                      <Link to="/dekoratyviniaiTriusiai">
                        Dekoratyviniai triušiai
                      </Link>
                      <Link to="/juruKiaulytes">Jūrų kiaulytės</Link>
                      <Link to="/sinsilos">Šinšilos</Link>
                      <Link to="/ziurkenai">Žiurkėnai</Link>
                      <Link to="/ziurkes">Žiurkės</Link>
                    </div>
                  </div>

                  <div className="animaListColumnContainer ropliai">
                    <div className="animalListColumnHeader">
                      <svg
                        width="28"
                        height="24"
                        viewBox="0 0 28 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.888215 8.7512C1.45043 8.01654 3.38196 8.04068 4.28218 8.79605C4.74437 9.18235 6.79316 11.5036 8.83506 13.956C12.5463 18.4123 13.4224 19.1263 14.0985 18.2467L14.4399 17.7983L12.0117 13.9767C9.12134 9.43069 8.57684 7.99307 9.19078 5.50623C9.19078 5.50623 9.40549 4.46567 9.77323 3.82582C10.0993 3.25843 10.6321 2.53584 10.6321 2.53584C10.6321 2.53584 11.5527 1.76953 12.1049 1.41831C12.6344 1.0815 13.619 0.88024 13.619 0.88024C15.4574 0.22835 17.7132 0.404263 19.2929 1.32864C21.0501 2.53584 21.6996 3.36018 23.2663 5.916C24.8046 8.06137 26.3671 10.2447 26.7396 10.7724C26.7396 10.7724 27.1836 11.2029 27.3398 11.6312C27.5665 12.2532 27.3398 13.4179 27.3398 13.4179C27.2535 15.3529 27.0155 16.2186 26.4637 16.567C25.9118 16.9153 23.9596 16.3945 22.4627 15.5529C22.4627 15.5529 21.6888 15.1695 21.3506 14.7976C21.0184 14.4321 20.814 13.7594 20.814 13.7594C20.5863 13.1523 19.4584 11.1449 18.3099 9.29272L16.2231 5.9298L15.5713 5.94359L14.9194 5.95739L14.6952 6.59549L14.471 7.23358L16.9716 11.1829C18.3099 13.104 19.066 13.956 19.6447 16.5532C19.862 18.3364 19.2205 20.261 17.965 21.6027C17.965 21.6027 17.4339 22.2104 16.9716 22.5168C16.4635 22.8535 15.5161 23.1445 15.5161 23.1445C13.5535 23.8171 12.0221 23.5101 10.3975 22.6375C7.31054 20.9793 6.39034 18.7715 4.34772 15.5529L0.560547 9.16511L0.881321 8.74775L0.888215 8.7512ZM3.43024 10.7621C4.0235 10.3861 3.8062 9.50312 3.06808 9.28238C2.12991 9.003 1.91951 9.34101 2.48173 10.2274C2.83009 10.7759 3.13706 10.9483 3.43024 10.7621ZM8.29354 19.0814C8.41081 19.1056 8.92474 18.7882 9.43521 18.3778L10.363 17.6328L9.90775 16.9222C8.96268 15.446 7.84516 14.4561 7.31054 14.6182C7.01046 14.7079 6.48964 14.839 6.14817 14.9045L5.53077 15.0252L6.80696 17.0326C7.50714 18.1363 8.17972 19.0573 8.29699 19.0814H8.29354ZM6.05159 13.818L6.95872 13.8422L6.6483 13.1765C6.47929 12.8109 5.93433 12.1003 5.4411 11.6037L4.54087 10.6965L4.34772 11.4726C4.07179 12.5867 4.94442 13.7904 6.04815 13.8215L6.05159 13.818ZM11.1494 22.0201C11.753 22.3029 12.7223 22.5271 13.3052 22.5237L14.364 22.5168L14.4986 21.5579C14.6676 20.33 14.1881 19.5815 13.2879 19.6643C12.8982 19.7023 12.2118 19.4505 11.7634 19.1056C10.9494 18.4813 10.2527 18.6434 9.4904 19.6367C9.02131 20.2507 9.82152 21.3992 11.1529 22.0201H11.1494ZM17.1303 21.0233C18.3961 19.6712 18.7997 18.6123 18.6755 16.9671L17.8029 14.1457L15.992 11.5036L13.4155 7.44743L13.012 7.70266C12.7912 7.84408 12.0324 7.89582 11.3288 7.81649C9.8767 7.65438 9.80082 7.86133 10.6321 9.70317L11.2219 11.0138L12.3877 10.9518C14.9539 10.8172 16.3404 12.9592 15.1367 15.2046C14.7986 15.8392 14.7469 16.4152 14.9987 16.8084C15.216 17.1464 15.2746 17.8052 15.1367 18.2743C14.9987 18.7434 15.047 19.3815 15.2505 19.7023C15.454 20.023 15.5885 20.6335 15.5471 21.0647C15.4436 22.1753 16.0645 22.1581 17.1303 21.0198V21.0233ZM14.2157 14.7941C14.3709 14.6079 14.4848 14.0319 14.4675 13.511L14.4365 12.5625L13.5052 12.1659C12.0773 11.5588 11.9289 11.9727 12.9775 13.6249L13.9329 15.1321L14.2157 14.7976V14.7941ZM11.3115 6.86107C12.7119 6.97144 13.8501 6.24712 14.3434 4.93299C14.8556 4.22489 14.7999 3.58826 14.1571 2.99457C13.8398 2.49444 13.4086 2.09089 13.2017 2.09779C12.2704 2.12883 9.63526 5.86772 10.0664 6.54375C10.1457 6.67137 10.708 6.81278 11.315 6.86107H11.3115ZM16.4128 4.95024L17.2613 5.3124L19.3308 8.85813C20.469 10.8069 21.59 12.7936 21.8177 13.273L22.235 14.1457L22.9248 13.8284C23.7113 13.4662 24.0458 13.7594 23.6492 14.4561L23.3836 14.9286L24.7322 15.3391L26.0808 15.7495L26.2395 14.2871L26.3981 12.8247L25.9601 13.104C25.2737 13.5421 24.9633 12.6694 25.6117 12.121L26.1946 11.6312L25.6773 11.0138C25.391 10.6758 24.4149 9.3755 23.5043 8.12691L21.8487 5.85736L20.8243 5.96774C19.0101 6.16434 17.2613 4.2949 17.8029 2.73934C18.1029 1.8736 17.6649 1.47005 16.3749 1.43211C14.8021 1.38382 14.4882 1.64596 15.047 2.53584C15.3057 2.94629 15.5057 3.53954 15.4954 3.86031C15.4747 4.59843 15.4229 4.53635 16.4163 4.96059L16.4128 4.95024ZM20.0345 4.80538C21.3003 5.19858 21.3451 4.69845 20.1655 3.36018C19.1377 2.19437 18.6824 2.15298 18.7031 3.23256C18.7203 4.18108 18.9721 4.47771 20.0345 4.80538Z"
                          fill="#110F0F"
                        />
                      </svg>

                      <span>Ropliai</span>
                    </div>
                    <div className="animalListColumn">
                      <Link to="/barzdotojiAgama">Barzdotoji agama</Link>
                      <Link to="/gyvatesIrZalciai">Gyvatės ir žalčiai</Link>
                      <Link to="/iguana">Iguana</Link>
                      <Link to="/leopardinisGekonas">Leopardinis gekonas</Link>
                      <Link to="/sausumosVezliai">Sausumos vėžliai</Link>
                      <Link to="/salmuotasisChameleonas">
                        Šalmuotasis chameleonas
                      </Link>
                      <Link to="/vandensVezliai">Vandens vėžliai</Link>
                    </div>
                  </div>

                  <div className="animaListColumnContainer pauksciai">
                    <div className="animalListColumnHeader">
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.81977 26.5983C4.473 25.7757 4.15762 25.0767 3.95304 22.4471L3.84223 20.9981L2.80658 21.1046C2.23548 21.1643 1.49817 21.0364 1.16574 20.8191L0.560547 20.427L1.26803 18.9481C1.65586 18.1341 2.41875 17.2646 2.96428 17.0174C3.5098 16.7702 4.16188 16.1182 4.40907 15.5684C4.66052 15.0228 5.30834 14.3708 5.8496 14.1236L6.83837 13.6718C6.83837 13.6718 6.79164 11.2766 6.8682 9.69543C6.94476 8.11426 6.61758 7.0337 7.23047 5.57413C7.46642 5.01222 8.01892 4.22738 8.01892 4.22738C8.45364 3.4858 9.31455 2.50128 9.92827 2.04526C12.096 0.742188 15.0208 0.218118 17.5102 0.834869C18.1424 0.991488 19.0488 1.47843 19.0488 1.47843C21.606 2.54817 23.3576 6.51603 21.4866 7.00615C21.0604 7.11696 20.5021 7.66249 20.2507 8.21654C19.9992 8.77059 19.3258 9.43545 18.7505 9.69543L17.7106 10.1685V13.5184C17.7063 15.6792 17.4847 17.2859 17.0883 18.0531C16.7474 18.7051 16.4703 19.3572 16.4703 19.5021C16.4703 19.647 17.5401 19.7451 18.8485 19.7195L21.2267 19.6726L22.0535 18.1681C22.9442 16.5486 24.2015 16.05 23.7582 17.4905C23.6176 17.9465 23.4002 18.6497 23.2724 19.0546L23.0422 19.7919L24.6192 19.6641C25.4843 19.5916 26.4773 19.728 26.8183 19.9624L27.4405 20.3886L26.8183 20.8063C26.456 21.0492 23.2042 21.2069 18.955 21.1813L11.714 21.1387L11.5052 23.3507L11.2963 25.5626L10.4695 25.52C10.0135 25.4944 9.36996 25.4006 9.04179 25.3111C8.70936 25.2216 8.41529 25.4262 8.38119 25.7672C8.23628 27.2588 8.1681 27.4208 7.67797 27.4208C7.39242 27.4208 6.56135 27.0543 5.82829 26.6068L5.81977 26.5983ZM6.47611 21.1686C6.19056 20.9896 5.80698 20.9384 5.62372 21.0492C5.01 21.4285 5.28276 24.2329 6.01582 25.0469L6.74034 25.8524L6.8682 23.6703C6.95344 22.2426 6.81706 21.3774 6.47611 21.1686ZM10.2607 22.7242C10.2607 21.143 10.0092 20.7551 9.18669 21.0705C8.47495 21.3433 8.42381 22.9245 9.10146 23.6064C9.92401 24.4289 10.2607 24.1732 10.2607 22.7242ZM15.652 17.9934C17.0883 16.8627 16.4489 10.4058 16.3766 9.65707L16.2658 2.38195L15.4944 2.23278C13.7129 1.89183 11.0918 2.64194 9.89418 3.83954C8.71096 4.97465 8.38119 6.2811 8.38119 7.96509L8.40676 10.8078L10.1073 10.5734C11.1235 10.402 12.0152 10.5383 12.9031 11.055C14.8977 12.3591 15.0383 15.8582 13.1972 18.3471C12.7241 18.9822 12.3405 19.5959 12.3405 19.7067C12.3405 20.2565 14.9318 18.9097 15.6648 17.9806L15.652 17.9934ZM13.3804 5.09255C13.0736 4.59816 13.8535 4.10804 14.4033 4.44899C14.8679 4.73454 14.561 5.48037 13.9814 5.48037C13.7811 5.48037 13.5083 5.30563 13.3762 5.0968L13.3804 5.09255ZM10.6869 18.9225C13.8237 17.2987 13.9771 11.6858 10.8787 11.6858C9.94532 11.6858 8.91393 12.6063 8.48348 13.8252C8.35136 14.2046 7.72911 14.7629 7.10687 15.0655C6.48463 15.3681 5.89648 15.8497 5.80272 16.1352L5.63225 16.6509H7.18785C8.90114 16.6509 10.2564 15.709 10.2564 14.5157C10.2564 14.0937 10.5377 13.7528 10.8787 13.7528C12.2084 13.7528 11.16 16.7106 9.57027 17.4308C9.01622 17.6823 7.48192 17.8911 6.16072 17.8911H3.76125L3.01116 18.7179L2.26106 19.5447H5.86239C8.27464 19.5447 9.8686 19.3359 10.6784 18.9182L10.6869 18.9225ZM18.7462 7.96509L19.4963 7.13827H17.7106V7.96509C17.7106 8.42111 17.7745 8.7919 17.8555 8.7919C17.9364 8.7919 18.3371 8.42111 18.7462 7.96509ZM21.0221 5.65938C21.0221 4.62373 19.198 2.62062 18.2263 2.59505C17.685 2.58226 17.4804 5.11385 17.9833 5.61676C18.32 5.95345 21.0178 5.98755 21.0178 5.65938H21.0221Z"
                          fill="#110F0F"
                        />
                      </svg>

                      <span>
                        <Link to="/pauksciai">Paukščiai</Link>
                      </span>
                    </div>
                    <div className="animalListColumn"></div>
                  </div>

                  <div className="animaListColumnContainer kita">
                    <div className="animalListColumnHeader">
                      <svg
                        width="28"
                        height="24"
                        viewBox="0 0 28 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.5009 21.2573C3.97346 20.1257 2.43674 17.6335 2.43674 14.6613V13.0806L1.47244 12.6534C1.47244 12.6534 0.979572 12.4759 0.743615 12.1383C0.457251 11.7286 0.596205 10.9494 0.596205 10.9494C0.653447 10.1172 1.14661 9.2806 2.00083 8.55847L3.31738 7.44446L2.78899 5.47182C2.49838 4.38423 2.3839 3.3759 2.53361 3.22619C3.04438 2.71542 3.68284 3.49919 3.96024 4.97867C4.34772 7.04377 4.82328 6.82802 5.42652 4.3226C5.73914 3.01925 6.17505 2.18263 6.53612 2.18263C7.27585 2.18263 7.28026 2.1474 6.47007 5.26047L5.80518 7.81874L6.30716 8.42197C7.0513 9.31582 7.27146 9.20134 8.7025 7.16706C9.55231 5.96058 10.8072 4.91263 12.2911 4.17289C12.2911 4.17289 13.4961 3.45187 14.3529 3.22619C15.253 2.9891 16.7295 3.04566 16.7295 3.04566C23.1758 3.07208 27.5702 9.21896 25.2673 14.9739L24.5892 16.6648L25.9234 17.8668C26.7776 18.633 27.2928 19.5312 27.35 20.3502L27.4425 21.6316L17.6058 21.724L7.76901 21.8165L6.48769 21.2441L6.5009 21.2573ZM25.9498 20.2534C25.9366 19.681 25.3378 19.0029 24.4131 18.5185L23.5104 18.043L21.8637 18.884C19.7325 19.9716 16.7735 19.9628 14.7305 18.8664L13.1365 18.0121H7.55326L7.13495 16.9157C6.90598 16.3125 6.71665 14.6789 6.71665 13.2831C6.71665 13.2831 7.00893 11.5029 6.5009 10.6526C6.25891 10.2476 5.86243 9.89264 5.86243 9.89264C4.83648 8.8667 3.59919 8.79624 2.68773 9.7077C1.76746 10.628 1.8423 11.4558 2.87265 11.7244L3.72687 11.9489V13.926C3.72687 16.6075 4.67357 18.677 6.3732 19.7162L7.78662 20.5792H16.8748C21.8725 20.5792 25.9586 20.4383 25.9542 20.2622L25.9498 20.2534ZM21.758 17.3781C26.0423 14.4676 25.2189 7.61619 20.2917 5.22965C15.9766 3.13813 10.9261 5.09315 8.80817 9.66807C8.03321 11.3413 7.7426 14.7053 8.25777 16.0483L8.51756 16.7264H10.3977C11.4325 16.7264 12.2779 16.6604 12.2779 16.5767C12.2779 16.493 12.0709 15.8414 11.8244 15.1192C11.4668 14.072 11.303 13.1777 11.82 12.1383C12.6434 9.08686 15.4658 7.42244 18.2838 8.3339C21.0182 9.21895 21.9077 13.0057 19.7149 14.4455C17.8303 15.6828 15.228 14.0228 16.7163 12.5346C17.4693 11.7816 18.3323 12.2131 17.9712 13.1598C17.7951 13.6133 17.9008 13.7807 18.2794 13.653C20.0848 13.0497 19.8382 10.2097 17.9228 9.54479C17.0083 8.99765 16.2026 9.07295 15.3425 9.6989C14.4355 10.082 13.7486 10.8041 13.3214 11.8256C13.3214 11.8256 13.0143 12.6995 12.978 13.2831C12.9417 13.8648 13.1365 14.767 13.1365 14.767C13.6032 16.176 14.9594 17.6951 16.1395 18.1266C17.7819 18.7255 20.2697 18.3952 21.7712 17.3693L21.758 17.3781Z"
                          fill="#110F0F"
                        />
                      </svg>

                      <span>Kita</span>
                    </div>
                    <div className="animalListColumn">
                      <Link to="/gyvalazdes">Gyvalazdės</Link>
                      <Link to="/seskai">Šeškai</Link>
                    </div>
                  </div>
                </div>
              </div> */}
            </li>
            <li>
              <Link
                to="/performanceReports"
                onMouseEnter={() => {
                  resetDropDowns();
                }}
              >
                Veiklos ataskaitos
              </Link>
            </li>
            <li>
              <Link
                to="/contacts"
                onMouseEnter={() => {
                  resetDropDowns();
                }}
              >
                Kontaktai
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
